export enum CollectionSlug {
  HOMEPAGE_CAROUSEL = 'homepage-carousel',
  BEST_SELLER = 'best-seller',
  PRE_ORDERS = 'pre-orders',
  FLASH_DISCOUNT = 'flash-discount',
}
